import {createSlice} from '@reduxjs/toolkit'
import api from "../api";
import {MODAL_VIEW_STATE, VIEW_STATE} from "../utils/enums";
import toast from "../utils/toast";
import utils from "../utils";

const bookmarkCoursesIds = localStorage.getItem('bookmarkCourses') ? JSON.parse(localStorage.getItem('bookmarkCourses')) : []
const bookmarkLessonsIds = localStorage.getItem('bookmarkLessons') ? JSON.parse(localStorage.getItem('bookmarkLessons')) : []
const slice = createSlice({
    name: 'course',
    initialState: {
        viewState: VIEW_STATE.LOADING,
        listViewState: VIEW_STATE.LOADING,
        modalViewState: MODAL_VIEW_STATE.NOT_LOADING,
        courses: [],
        lessons: [],
        hasMore: true,
        course: null,
        lesson: null,
        bookmarkCourses: bookmarkCoursesIds,
        bookmarkLessons: bookmarkLessonsIds
    },
    reducers: {
        setViewState: (state, action) => {
            state.viewState = action.payload
        },
        setModalViewState: (state, action) => {
            state.modalViewState = action.payload
        },
        setListViewState: (state, action) => {
            state.listViewState = action.payload
        },
        setCourses: (state, action) => {
            state.hasMore = action.payload.length > 0 && action.payload.length % global.PAGE_SIZE === 0
            state.courses = action.payload
            state.listViewState = VIEW_STATE.LOADED
        },
        setLessons: (state, action) => {
            state.hasMore = action.payload.length > 0 && action.payload.length % global.PAGE_SIZE === 0
            state.lessons = action.payload
            state.listViewState = VIEW_STATE.LOADED
        },
        setCourse: (state, action) => {
            state.course = action.payload
            state.viewState = VIEW_STATE.LOADED
        },
        setLesson: (state, action) => {
            state.lesson = action.payload
            state.viewState = VIEW_STATE.LOADED
        },
        addCourses: (state, action) => {
            state.hasMore = action.payload.length > 0 && action.payload.length % global.PAGE_SIZE === 0
            state.courses = [...state.courses, ...action.payload]
        },
        addLessons: (state, action) => {
            state.hasMore = action.payload.length > 0 && action.payload.length % global.PAGE_SIZE === 0
            state.lessons = [...state.lessons, ...action.payload]
        },
        refreshBookmark: (state, action) => {
            state.bookmarkCourses=localStorage.getItem('bookmarkCourses') ? JSON.parse(localStorage.getItem('bookmarkCourses')) : []
            state.bookmarkLessons= localStorage.getItem('bookmarkLessons') ? JSON.parse(localStorage.getItem('bookmarkLessons')) : []
        },
        toggleBookmark: (state, action) => {
            if (state.bookmarkCourses.some(bookmarkCourseId => bookmarkCourseId === action.payload)) state.bookmarkCourses = state.bookmarkCourses.filter(bookmarkCourseId => bookmarkCourseId !== action.payload)
            else state.bookmarkCourses = [...state.bookmarkCourses, action.payload]
            localStorage.setItem('bookmarkCourses', JSON.stringify(state.bookmarkCourses))
        },
        toggleBookmarkLesson: (state, action) => {
            if (state.bookmarkLessons.some(bookmarkLessonId => bookmarkLessonId === action.payload)) state.bookmarkLessons = state.bookmarkLessons.filter(bookmarkLessonId => bookmarkLessonId !== action.payload)
            else state.bookmarkLessons = [...state.bookmarkLessons, action.payload]
            localStorage.setItem('bookmarkLessons', JSON.stringify(state.bookmarkLessons))
        },
        onError: (state, action) => {
            state.modalViewState = MODAL_VIEW_STATE.NOT_LOADING
            toast.error(action.payload);
        },
    },
});

export default slice.reducer
const {setViewState, setCourses, addCourses, setCourse,setLessons, addLessons, setListViewState, refreshBookmark,toggleBookmark, toggleBookmarkLesson,setModalViewState,onError,setLesson} = slice.actions


export const onRefreshBookmark = () => dispatch => dispatch(refreshBookmark())
export const onBookmarkClick = (courseId) => dispatch => dispatch(toggleBookmark(courseId))
export const onBookmarkLessonClick = (lessonId) => dispatch => dispatch(toggleBookmarkLesson(lessonId))
export const getCourses = (page, search) => async dispatch => {
    try {
        if (page === 0) dispatch(setListViewState(VIEW_STATE.LOADING))
        const {data} = await api.course.getCourses(page, search)
        if (page === 0) dispatch(setCourses(data?.data));
        else dispatch(addCourses(data?.data));
    } catch (e) {
        dispatch(setListViewState(VIEW_STATE.ERROR))
    }
}
export const getBookmarkCourses = (bookmarkCourses,page) => async dispatch => {
    try {
        if (page === 0) dispatch(setListViewState(VIEW_STATE.LOADING))
        const {data} = await api.course.getBookmarkCourses(bookmarkCourses,page)
        if (page === 0) dispatch(setCourses(data?.data));
        else dispatch(addCourses(data?.data));
    } catch (e) {
        dispatch(setListViewState(VIEW_STATE.ERROR))
    }
}
export const getBookmarkLessons = (bookmarkLessons,page) => async dispatch => {
    try {
        if (page === 0) dispatch(setListViewState(VIEW_STATE.LOADING))
        const {data} = await api.course.getBookmarkLessons(bookmarkLessons,page)
        if (page === 0) dispatch(setLessons(data?.data));
        else dispatch(addLessons(data?.data));
    } catch (e) {
        dispatch(setListViewState(VIEW_STATE.ERROR))
    }
}
export const getBoughtCourses = (page) => async dispatch => {
    try {
        if (page === 0) dispatch(setListViewState(VIEW_STATE.LOADING))
        const {data} = await api.course.getBoughtCourses(page)
        if (page === 0) dispatch(setCourses(data?.data));
        else dispatch(addCourses(data?.data));
    } catch (e) {
        dispatch(setListViewState(VIEW_STATE.ERROR))
    }
}
export const getCourseCategory = (courseCategoryId,page) => async dispatch => {
    try {
        if (page === 0) dispatch(setViewState(VIEW_STATE.LOADING))
        const {data} = await api.courseCategory.getCourseCategory(courseCategoryId,page)
        if (page === 0) dispatch(setCourses(data?.data));
        else dispatch(addCourses(data?.data));
    } catch (e) {
        dispatch(setListViewState(VIEW_STATE.ERROR))
    }
}
export const getHomeRow = (homeId,page) => async dispatch => {
    try {
        if (page === 0) dispatch(setViewState(VIEW_STATE.LOADING))
        const {data} = await api.home.getHomeRow(homeId,page)
        if (page === 0) dispatch(setCourses(data?.data));
        else dispatch(addCourses(data?.data));
    } catch (e) {
        dispatch(setListViewState(VIEW_STATE.ERROR))
    }
}
export const getCourse = (courseId) => async dispatch => {
    try {
        dispatch(setViewState(VIEW_STATE.LOADING))
        const {data} = await api.course.getCourse(courseId)
        dispatch(setCourse(data?.data));
    } catch (e) {
        dispatch(setViewState(VIEW_STATE.ERROR))
    }
}
export const getLesson = (courseId,lessonId) => async dispatch => {
    try {
        dispatch(setViewState(VIEW_STATE.LOADING))
        const {data} = await api.course.getLesson(courseId,lessonId)
        dispatch(setLesson(data?.data));
    } catch (e) {
        dispatch(setViewState(VIEW_STATE.ERROR))
    }
}
export const paymentRequest = (courseId, offCode,onSuccess,t) => async dispatch => {
    try {
        dispatch(setModalViewState(MODAL_VIEW_STATE.LOADING))
        const {data} = await api.course.paymentRequest(courseId, offCode)
        onSuccess(data?.data)
        dispatch(setModalViewState(MODAL_VIEW_STATE.NOT_LOADING))
    } catch (e) {
        const message = e.response?.data?.message ?? t("errorInConnection")
        dispatch(onError(utils.isPersian(message) ? message : t("errorInConnection")))
    }
}
